import { defineComponent as t, createBlock as n, openBlock as o, unref as d, mergeProps as p, withCtx as c, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceParcelFilled",
  __name: "IconReassuranceParcelFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const r = a;
    return (m, l) => (o(), n(d(i), p(r, { "view-box": "0 0 48 48" }), {
      default: c(() => [...l[0] || (l[0] = [
        e("g", { "clip-path": "url(#l91h5la)" }, [
          e("path", {
            "fill-rule": "evenodd",
            d: "m21.165 11.528-8.598-1.593a1.5 1.5 0 0 0-1.748 1.201L7.157 30.894a1.5 1.5 0 0 0 1.202 1.748l26.075 4.833a1.5 1.5 0 0 0 1.749-1.201l3.661-19.758a1.5 1.5 0 0 0-1.201-1.749l-8.598-1.593-1.665 8.985a.5.5 0 0 1-.927.153l-2.777-4.946-4.365 3.623a.5.5 0 0 1-.811-.476l1.665-8.985m9.094 15.39c-.13.703-.514 1.224-.856 1.16-.342-.062-.513-.687-.383-1.39.13-.702.514-1.224.856-1.16.342.063.513.687.383 1.39m2.715-.147c-.351-.018-.605-.61-.578-1.322.027-.712.334-1.286.685-1.27.35.018.604.61.577 1.322-.026.713-.297 1.294-.684 1.27m-7.22 1.033a.254.254 0 0 1 .36.067 10.572 10.572 0 0 0 1.239 1.52 7.2 7.2 0 0 0 1.502 1.235 7.617 7.617 0 0 0 3.734 1.008.264.264 0 0 1 .038.514 6.523 6.523 0 0 1-2.158-.018 6.76 6.76 0 0 1-2.063-.736 7.976 7.976 0 0 1-.908-.618 5.642 5.642 0 0 1-1.89-2.655.263.263 0 0 1 .182-.31l-.037-.007",
            "clip-rule": "evenodd"
          }),
          e("path", { d: "m29.062 12.992-6.914-1.282-1.413 7.627 4.226-3.507 2.688 4.789 1.413-7.627" }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M12.75 8.95a2.5 2.5 0 0 0-2.914 2.003L6.174 30.712a2.5 2.5 0 0 0 2.002 2.914l26.076 4.833a2.5 2.5 0 0 0 2.914-2.003l3.662-19.758a2.5 2.5 0 0 0-2.003-2.914L12.75 8.951",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "l91h5la" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
